import type { Chat, Worktree } from "./models.ts";

/** Stable across chat freshness/reordering. Never derive authors from the viewer. */
export function taskParticipantIds(worktree: Pick<Worktree, "id" | "createdBy">, chats: readonly Pick<Chat, "id" | "worktreeId" | "createdAt" | "createdBy" | "participantIds">[]): string[] {
  const ids = new Set<string>([worktree.createdBy]);
  for (const chat of chats.filter((chat) => chat.worktreeId === worktree.id)
    .sort((a, b) => a.createdAt - b.createdAt || a.id.localeCompare(b.id))) {
    ids.add(chat.createdBy);
    for (const id of [...(chat.participantIds ?? [])].sort()) ids.add(id);
  }
  return [...ids].filter(Boolean);
}
